import PageHeader from '../components/PageHeader';
import bgTwo from '../assets/images/bgTwo.png';
import aaed from '../assets/images/sessions/aaed.png';
import abdelaziz from '../assets/images/sessions/abdelaziz.png';
import ali from '../assets/images/sessions/ali.png';
import binSaud from '../assets/images/sessions/binSaud.png';
import haitham from '../assets/images/sessions/haitham.png';
import shamry from '../assets/images/sessions/shamry.png';
import ibrahim from '../assets/images/sessions/ibrahim.png';
import salman from '../assets/images/sessions/salman.png';
import fahd from '../assets/images/sessions/fahd.png';
import avatar from '../assets/images/sessions/avatar.png';
import timeBG from '../assets/images/timeBG.png';
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';

const speakers = [
  {
    name: "معالي عبد العزيز بن سعود الدحيم",
    title: " مساعد وزير التجارة",
    image: abdelaziz
  },
  {
    name: "سعادة المهندس عبد الله بن سعود الحماد",
    title: "الرئيس التنفيذي للهيئة العامة للعقار",
    image: binSaud
  },
  {
    name: "الأستاذ سعود الشمري",
    title: "رئيس الدائرة الأولى في لجنة الفصل في منازعات الأوراق المالية",
    image: shamry
  },
  {
    name: "الدكتور فهد الماجد",
    title: "نائب محافظ هيئة الأوقاف",
    image: fahd
  },
  {
    name: "الدكتور عائذ المبارك",
    title: "الرئيس التنفيذي في المركز الوطني للمنشآت العائلية",
    image: aaed
  },
  {
    name: "الدكتور ابراهيم الحيدري",
    title: "الرئيس التنفيذي لصندوق الوقف الصحي في وزارة الصحة - سابقاً -",
    image: ibrahim
  },
  {
    name: "الأستاذ هيثم الفايز",
    title: "الرئيس التنفيذي لشركة وقف سليمان الراجحي القابضة",
    image: haitham
  },
  {
    name: "الأستاذ سلمان التخيفي",
    title: "مدير عام التحليل وذكاء الأعمال في المركز الوطني للتنافسية",
    image: salman
  },
  {
    name: "الاستاذ علي الهزاني",
    title: "مدير عام الحوكمة المؤسسية في شركة الاتصالات السعودية",
    image: ali
  },
  ];

const Speakers = () => {
    return (
        <>
            <PageHeader image={bgTwo} title="المتحدثون" />

            <AnimatedSection as="div" dir="rtl" className="w-full bg-contain bg-[#F5F6F8] p-6 md:p-12 flex flex-col items-center" style={{ backgroundImage: `url(${timeBG})` }}>
                <div className="w-full max-w-[1200px]">
                    <AnimatedGroup className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 w-full" stagger={0.08}>
                    {speakers.map((speaker, index) => (
                        <AnimatedItem key={index} className="flex justify-center md:justify-start my-4">
                        <div dir="ltr" className="flex items-center w-full max-w-[500px]">
                            {speaker.image ? (
                                <img
                                src={speaker.image}
                                alt={speaker.name}
                                className="w-[144px] h-[144px] rounded-full shrink-0 border border-[#3E82B9] z-10 object-cover bg-gray-200 shadow-md -mr-[72px] relative"
                                />
                            ) : (
                                <img
                                src={avatar}
                                alt={speaker.name}
                                className="w-[144px] h-[144px] rounded-full shrink-0 border border-[#3E82B9] z-10 bg-white object-none shadow-md -mr-[72px] relative"
                                />
                            )}

                            <div className="border border-[#3E82B9] rounded-[12px] pl-[75px] pr-6 py-5 min-h-[120px] flex flex-col justify-center bg-white flex-1 min-w-0">
                                <h4 dir="rtl" className="text-[#3E82B9] text-sm md:text-base font-bold mb-2">
                                {speaker.name}
                                </h4>
                                <p dir="rtl" className="text-[#031246] text-[12px] md:text-[13px] font-[400] leading-[1.6]">
                                {speaker.title}
                                </p>
                            </div>
                        </div>
                        </AnimatedItem>
                    ))}
                    </AnimatedGroup>
                </div>
            </AnimatedSection>
        </>
    );
};

export default Speakers;
